import { render } from "./SankeyChartShow.vue?vue&type=template&id=52e9300f"
import script from "./SankeyChartShow.vue?vue&type=script&lang=js"
export * from "./SankeyChartShow.vue?vue&type=script&lang=js"

import "./SankeyChartShow.vue?vue&type=style&index=0&id=52e9300f&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__